export enum LeadMagnetStories {
  Wallex = 'Wallex',
  TechDueDiligence = 'TechDueDiligence',
}
